module.exports = "https://www.gc-qa.gnp.com.mx/a32e1da53078bdc29fdf84406da79fcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/02-condiciones-over.svg
// module id = 8035
// module chunks = 0